import styled from 'styled-components';
import { COLORS } from '@/styles/colors';
import { bodySmall } from '@/styles/typography';

export const SecureLinkShell = styled.div`
  min-height: 100vh;
  background: ${COLORS.grey[300]};
  display: flex;
  justify-content: center;
  padding: 48px 16px;
`;

export const SecureLinkCard = styled.div<{ $maxWidth?: string }>`
  width: 100%;
  max-width: ${({ $maxWidth }) => $maxWidth ?? '720px'};
  height: fit-content;
  padding: 32px;
  border-radius: 12px;
  background: ${COLORS.white};
  border: 1px solid ${COLORS.grey[200]};
  display: flex;
  flex-direction: column;
  gap: 18px;
`;

export const InstructionRow = styled.div`
  display: grid;
  grid-template-columns: 200px minmax(0, 1fr) auto;
  gap: 16px;
  align-items: center;
  padding: 11px 0;
  border-bottom: 1px solid ${COLORS.grey[200]};
  ${bodySmall};

  &:last-child {
    border-bottom: 0;
  }
`;
